import(/* webpackMode: "eager" */ "/app/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/web/src/components/providers.tsx");
